export const uk = {
    archive: 'Весь архив',
    load: 'Показать еще'
};
